module.exports = __webpack_public_path__ + "assets/img/receive-img.8b782cda.png";